// feat_347 — Tab "Mensajes" de /Settings.
//
// 🔴 REGLA #1 DE ESTA PANTALLA: los 8 TabPanel quedan SIEMPRE MONTADOS (el shell
// los oculta con `hidden`, nunca los desmonta). 21 campos de texto guardan con
// `onBlur`; si al cambiar de tab React desmontara el input, el onBlur NO dispara
// y el usuario pierde lo tipeado sin ningún aviso. NO convertir esto en render
// condicional ni en lazy.
//
// Todo el estado vive en el padre (`Settings/index.js`) y llega por `ctx`.
// El JSX es un MOVIMIENTO VERBATIM de index.js — Fase 1 no cambia ni un pixel.

import React from "react";

import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";

import { i18n } from "../../../translate/i18n.js";

const TabMensajes = ({ ctx }) => {
	const {
		classes,
		saveSetting,
		signatureEnabled, setSignatureEnabled,
		signatureQuoteStyle, setSignatureQuoteStyle,
		outboundTypingEnabled, setOutboundTypingEnabled,
		outboundTypingAiEnabled, setOutboundTypingAiEnabled,
		cancelScheduledOnReply, setCancelScheduledOnReply,
	} = ctx;

	return (
		<>
			{/* Firma de mensajes */}
			<Typography variant="body2" className={classes.sectionTitle} gutterBottom>
				{i18n.t("settingsExtra.firmaTitle")}
			</Typography>
			<Paper className={classes.paper} elevation={1}>
				<FormControlLabel
					control={
						<Switch
							checked={signatureEnabled}
							onChange={async (e) => {
								const val = e.target.checked;
								setSignatureEnabled(val);
								await saveSetting("signatureEnabled", val ? "enabled" : "disabled");
							}}
							color="primary"
						/>
					}
					label={i18n.t("settingsExtra.firmaEnabledLabel")}
				/>
				<Typography variant="caption" display="block" color="textSecondary" style={{ marginLeft: 46 }}>
					{i18n.t("settingsExtra.firmaEnabledHelp")}
				</Typography>
				<div style={{ opacity: signatureEnabled ? 1 : 0.5, marginTop: 4 }}>
					<FormControlLabel
						control={
							<Switch
								checked={signatureQuoteStyle}
								disabled={!signatureEnabled}
								onChange={async (e) => {
									const val = e.target.checked;
									setSignatureQuoteStyle(val);
									await saveSetting("signatureQuoteStyle", val ? "enabled" : "disabled");
								}}
								color="primary"
							/>
						}
						label={i18n.t("settingsExtra.firmaQuoteLabel")}
					/>
					<Typography variant="caption" display="block" color="textSecondary" style={{ marginLeft: 46 }}>
						{i18n.t("settingsExtra.firmaQuoteHelp")}
					</Typography>
				</div>
			</Paper>

			{/* Outbound typing — feat_177: el contacto ve "escribiendo..." al asesor */}
			<Typography variant="body2" className={classes.sectionTitle} gutterBottom>
				{i18n.t("settingsExtra.outboundTypingSectionTitle")}
			</Typography>
			<Paper className={classes.paper} style={{ flexDirection: "column", alignItems: "flex-start" }}>
				<FormControlLabel
					control={
						<Switch
							checked={outboundTypingEnabled}
							onChange={async (e) => {
								const val = e.target.checked;
								setOutboundTypingEnabled(val);
								await saveSetting("outboundTypingEnabled", val ? "true" : "false");
							}}
							color="primary"
						/>
					}
					label={i18n.t("settingsExtra.outboundTypingLabel")}
				/>
				<Typography variant="caption" display="block" color="textSecondary" style={{ marginLeft: 46 }}>
					{i18n.t("settingsExtra.outboundTypingHelp")}
				</Typography>
				<FormControlLabel
					control={
						<Switch
							checked={outboundTypingAiEnabled}
							onChange={async (e) => {
								const val = e.target.checked;
								setOutboundTypingAiEnabled(val);
								await saveSetting("outboundTypingAiEnabled", val ? "true" : "false");
							}}
							color="primary"
						/>
					}
					label={i18n.t("settingsExtra.outboundTypingAiLabel")}
				/>
				<Typography variant="caption" display="block" color="textSecondary" style={{ marginLeft: 46 }}>
					{i18n.t("settingsExtra.outboundTypingAiHelp")}
				</Typography>
			</Paper>

			{/* Mensajes Programados */}
			<Typography variant="body2" className={classes.sectionTitle} gutterBottom>
				{i18n.t("scheduledMessages.mode_button")}
			</Typography>
			<Paper className={classes.paper} style={{ flexDirection: "column", alignItems: "flex-start" }}>
				<FormControlLabel
					control={
						<Switch
							checked={cancelScheduledOnReply}
							onChange={async (e) => {
								const val = e.target.checked;
								setCancelScheduledOnReply(val);
								await saveSetting("cancelScheduledOnReply", val ? "true" : "false");
							}}
							color="primary"
						/>
					}
					label={i18n.t("settingsExtra.cancelScheduledOnReplyLabel")}
				/>
			</Paper>
		</>
	);
};

export default TabMensajes;
